export type PartStatus = 'requested' | 'arriving' | 'cancelled' | 'delivered';

export const PART_STATUS = {
  REQUESTED: 'requested',
  ARRIVING: 'arriving',
  CANCELLED: 'cancelled',
  DELIVERED: 'delivered'
} as const;

export const STATUS_TEXT = {
  [PART_STATUS.REQUESTED]: 'Part requested',
  [PART_STATUS.ARRIVING]: 'Arriving on',
  [PART_STATUS.CANCELLED]: 'Cancelled',
  [PART_STATUS.DELIVERED]: 'Delivered'
};
